// extracted by mini-css-extract-plugin
module.exports = {"spacer":"X_dg","title-container":"X_dh","titleContainer":"X_dh","title":"X_bH"};